import './view-nav-modal.css';
import { h } from 'preact';
import { useRef, useState, useEffect } from 'preact/hooks';

import ViewNavButton from './components/ViewNavButton/ViewNavButton';
import ViewNavButtonPrevNext from './components/ViewNavButtonPrevNext/ViewNavButtonPrevNext';
import ViewNavSelected from './components/ViewNavSelected/ViewNavSelected';

export default function ViewNavModal({ views, activeView, onClick, windowSize }) {
	const refNavContainer = useRef(null);
	const [isMenuOverflown, setIsMenuOverflown] = useState(true);

	useEffect(() => {
		if (refNavContainer.current) {
			setIsMenuOverflown(isOverflownHorizontal(refNavContainer.current));
		}
	}, [refNavContainer, windowSize]);

	/**
	 * @param {array} views
	 * @param {object} activeView
	 * @param {string} nextOrPrevious either 'next' or 'previous'
	 * @return {object|null} a view object or null when not found
	 */
	function getView(views, activeView, nextOrPrevious) {
		for (let index=0;index<views.length;index++) {
			if (views[index].id === activeView.id) {
				return views[nextOrPrevious === 'next' ? index+1 : index-1];
			}
		}

		return null;
	}

	const prevView = getView(views, activeView, 'previous');
	const nextView = getView(views, activeView, 'next');

	/**
	 * @param {element} DOM element
	 */
	const isOverflownHorizontal = ({ clientWidth, scrollWidth }) => scrollWidth > clientWidth;

	return (
		<div class={'view-nav-modal-wrapper' + (isMenuOverflown ? ' is-overflown' : '')}>
			<nav class="view-nav-modal-container" ref={refNavContainer}>
				{views.length > 0 ?
					<div class="view-nav-modal-navigation-container">
						<ul class={'view-nav-view-items-container' + (!isMenuOverflown ? ' is-active' : '')} aria-hidden={isMenuOverflown}>
							{views.map(view => (
								<li class="view-nav-view-item-container">
									<ViewNavButton {...view} isSelected={activeView && activeView.id === view.id} onClick={onClick} />
								</li>
							))}
						</ul>
						<div class={'view-nav-next-prev-container' + (isMenuOverflown ? ' is-active' : '')} aria-hidden={!isMenuOverflown}>
							{prevView ?
								<ViewNavButtonPrevNext {...prevView} onClick={onClick} /> : ''}
							<ViewNavSelected {...activeView} />
							{nextView ?
								<ViewNavButtonPrevNext {...nextView} isNextButton onClick={onClick} /> : ''}
						</div>
					</div>
					: ''}
			</nav>
		</div>
	);
}
